import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const Upload = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 -6 16 24" {...props}>
    <path
      d="M8.00049 8.1875L8.00049 1.1875"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6255 3.8125L8.00049 1.1875L5.37549 3.8125"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.563 8.1875V9.0625C14.563 9.52663 14.3786 9.97175 14.0504 10.2999C13.7222 10.6281 13.2771 10.8125 12.813 10.8125H3.18799C2.72386 10.8125 2.27874 10.6281 1.95055 10.2999C1.62236 9.97175 1.43799 9.52663 1.43799 9.0625V8.1875"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
